import { render, staticRenderFns } from "./new_daily_menu.vue?vue&type=template&id=83ba982a&scoped=true"
import script from "./new_daily_menu.vue?vue&type=script&lang=js"
export * from "./new_daily_menu.vue?vue&type=script&lang=js"
import style0 from "./new_daily_menu.vue?vue&type=style&index=0&id=83ba982a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "83ba982a",
  null
  
)

export default component.exports